import React, { useState, useEffect } from 'react'
import {
  Row,
  Col,
  Steps,
  Form,
  Input,
  Select,
  DatePicker,
  Card,
  Upload,
  Button,
  Modal,
  Empty,
  notification,
} from 'antd'

const { TextArea } = Input

import styled from 'styled-components'
import ColorList from 'constants/color.constants'
import { SearchOutlined } from '@ant-design/icons'

import { getCookie } from 'helper/cookie'

import {
  getResultSupportNeed,
  addSupportNeed,
  getResultOptionSupportNeed,
  deleteSupportNeed,
  updateSupportNeed,
  updateStatusSupportNeed,
  sendMailSupportNeed,
} from 'api/Project/supportneed'

import { useForm } from 'antd/lib/form/Form'

import lang from 'lang/en'
import { Data } from '@react-google-maps/api'

const Container = styled.div`
  background-color: ${ColorList.white};

  width: 100;
  height: auto;
  margin-top: 16px;
  margin-left: 4px;
`
const { Option } = Select
const initalState = {
  data: [],
  isLoading: true,
}

const AddTaskKPIFinance = (props) => {
  const {
    modalState,
    setModalState,
    viewNameBtn,
    viewDisplayOk,
    viewDisable,
    typeBtn,
    dataEdit,
    idEditPRJ,
    getSupportNeed,
    stateKPI,
    pageTaskInboxDetail,
    getLogList,
  } = props
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')
  const language = getCookie('lang')
  const word = lang[language]
  const companyIDUser = getCookie('companyId_project')
  const [form] = Form.useForm()

  const [dataOption, setDataOption] = useState(initalState.data)

  const setFieldValue = () => {
    if (typeBtn === 'edit') {
      if (pageTaskInboxDetail == 'taskinboxdetail') {
        form.setFieldsValue({
          type: dataEdit.support_type_id,
          remark: dataEdit.description,
        })
      } else {
        form.setFieldsValue({
          type: dataEdit.type,
          remark: dataEdit.remark,
        })
      }
    } else {
      form.setFieldsValue({
        type: null,
        remark: null,
      })
    }
  }

  const getOption = async () => {
    getResultOptionSupportNeed({
      // company_id: 43,
      company_id: parseInt(companyIDUser),
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataOption([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataOption(data)
        } else {
          setDataOption([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataOption([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const onFinish = (value) => {
    let dataArray = []
    let idsprintflow_id = ''
    if (stateKPI == 'project') {
      idsprintflow_id = 0
    } else {
      idsprintflow_id = stateKPI
    }
    if (typeBtn == 'add') {
      setModalState(false)
      if (pageTaskInboxDetail == 'taskinboxdetail') {
        dataArray = {
          project_id: parseInt(idEditPRJ),
          sprintflow_id: idsprintflow_id,
          description: value.remark,
          support_type_id: value.type,
          taskinbox: 'Y',
        }
      } else {
        dataArray = {
          project_id: parseInt(idEditPRJ),
          sprintflow_id: idsprintflow_id,
          description: value.remark,
          support_type_id: value.type,
          taskinbox: 'N',
        }
      }

      try {
        addSupportNeed({
          params: dataArray,
          token: token,
        }).then((res) => {
          console.log(res)
          if (res.status === 200) {
            if (pageTaskInboxDetail == 'taskinboxdetail') {
              getLogList()
            }
            getSupportNeed()
            form.setFieldsValue({
              type: null,
              remark: null,
            })
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else {
      if (pageTaskInboxDetail == 'taskinboxdetail') {
        dataArray = {
          project_id: parseInt(idEditPRJ),
          sprintflow_id: idsprintflow_id,
          description: value.remark,
          support_type_id: value.type,
          taskinbox: 'Y',
        }
      } else {
        dataArray = {
          project_id: parseInt(idEditPRJ),
          sprintflow_id: idsprintflow_id,
          description: value.remark,
          support_type_id: value.type,
          taskinbox: 'N',
        }
      }

      try {
        updateSupportNeed({
          supportneed_id: dataEdit.id,
          params: dataArray,
          token: token,
        }).then((res) => {
          console.log(res)
          if (res.status === 200) {
            if (pageTaskInboxDetail == 'taskinboxdetail') {
              getLogList()
            }
            setModalState(false)
            getSupportNeed()
            form.setFieldsValue({
              type: null,
              remark: null,
            })
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }

  const onCancel = () => {
    setModalState(false)
    form.setFieldsValue({
      type: null,
      remark: null,
    })
  }

  useEffect(() => {
    if (token) {
      setFieldValue()
      getOption()
    }
  }, [token, modalState])

  return (
    <Modal
      maskClosable={false}
      className="no-breadcrumb save-and-cancel-modal style-modal disable-page"
      visible={modalState}
      onOk={form.submit}
      onCancel={() => onCancel()}
      destroyOnClose={true}
      okText="Save"
      title="Support Need"
      cancelText={viewNameBtn}
      okButtonProps={{ style: { display: viewDisplayOk } }}
    >
      <Form form={form} onFinish={onFinish}>
        <div className="container-item-inner-modal">
          <h4 className="label">{word['addtask_supportneed_title_modal_type']}</h4>
          <Form.Item
            name="type"
            rules={[
              {
                required: true,

                message: word['addtask_supportneed_typesupportneed'],
              },
            ]}
          >
            <Select
              className="Select Select-Custom"
              style={{ width: '100%' }}
              placeholder="Type "
              size="large"
              allowClear
              showSearch
              disabled={viewDisable}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {dataOption.map((item) => (
                <Option value={item.id}>{item.title_en}</Option>
              ))}
            </Select>
          </Form.Item>
          <h4 className="label" style={{ marginTop: 24 }}>
            {word['addtask_supportneed_title_modal_remark']}
          </h4>
          <Form.Item
            name="remark"
            rules={[
              {
                whitespace: true,
                required: true,
                message: word['addtask_supportneed_remark'],
              },
            ]}
          >
            <TextArea
              disabled={viewDisable}
              autoSize={{ minRows: 3, maxRows: 6 }}
              style={{ height: '50px', borderRadius: '5px' }}
              maxLength={200}
            />
          </Form.Item>
        </div>
      </Form>
    </Modal>
  )
}
export default AddTaskKPIFinance
